export const enumsZh = {
        address:"https://official.juhaowu.cn",
        // banner视频
        atoscnMp4:"https://image.juhaowu.cn/cn_video/video/atos-cn.mp4",
        atoscnMp4480: "https://image.juhaowu.cn/cn_video/video/atoshi-480p.mp4",
        atoscnMp4720: "https://image.juhaowu.cn/cn_video/video/atoshi-720p.mp4",
        atoscnMp41080: "https://image.juhaowu.cn/cn_video/video/atoshi-1080p.mp4",
        // ceo视频
        ceoAtoscnMp4:"https://image.juhaowu.cn/cn_video/video/CNATOSHI.mp4",
        ceoAtoscnMp4480: "https://image.juhaowu.cn/cn_video/video/CNATOSHI480p.mp4",
        ceoAtoscnMp4720: "https://image.juhaowu.cn/cn_video/video/CNATOSHI720p.mp4",
        ceoAtoscnMp41080: "https://image.juhaowu.cn/cn_video/video/CNATOSHI1080p.mp4",
        // 正式
        downloadUrl:"https://share-plus.juhaowu.net/#/xiazaiye?from=singlemessage",
        // 测试
        // downloadUrl:"http://appone.libangtianbo.net.cn/#/xiazaiye",
        // h5 下载海外版 正式
        seaAtoshiDownloadUrl:"https://www.atoshi.org/globaldownload/#/?language=zh",
        // 乐唰下载
        leshuaDownload:"https://leshua.info",
        // 游戏下载
        gamesDownload:"https://game-img.atoshi.mobi/official/box_mobile.jpg",
        // 区块链地址
        chainAtoshiUrl:"https://scan.atoverse.info/",
        // 钱包地址
        walletUrl: "https://wallet.atoshi.org",
        // 原宇宙
        metatUrl: "https://meta.libangbo.cn/",
        // 密码箱
        keyUrl: "https://h5.atoshikey.com/#/introduction?language=chinese",
        // 小原子早晚安
        miniDaily: "https://open.weixin.qq.com/qr/code?username=gh_3069259a3533",
        // 原子链AI
        atoshiAI: "https://open.weixin.qq.com/qr/code?username=gh_a64d66abe4b5",
        // 原子世界
        atoshiYzsj: "https://share-plus.juhaowu.net/#/download?from=singlemessage",
};

export const enumsEn = {
        addressEn:"https://en.juhaowu.cn",
        address:"https://official.juhaowu.cn",
        downloadUrl:"https://share-plus.juhaowu.net/#/xiazaiye?from=singlemessage",
        globalDownloadUrl:"https://www.atoshi.org/globaldownload/#/?language=en",
        detokUrl:"https://www.atoshi.info/detok/#/",
        videoMp4:"https://video.juhaowu.cn/video/enatoshi.mp4",
        bannerYoutubeId:"OYeDNoLZRUU",
        ceoVideoMp4:"https://image.juhaowu.cn/cn_video/video/ENATOSHI.mp4",
        ceoVideoYoutubeId:"zPN8Yc6eX_Y",
        // 区块链地址
        chainAtoshiUrl:"https://scan.atoshi.org/en",
        // 密码箱
        keyUrl: "https://h5.atoshikey.com/#/introduction?language=english",
};

export const enumsImages = {
        addressZh:"https://video2.juhaowu.cn/static-web/mobile_img/mobile_zh",
        addressEn:"https://video2.juhaowu.cn/static-web/mobile_img/mobile_en",
        addressCommon:"https://video2.juhaowu.cn/static-web/mobile_img/common/img"

};





// WEBPACK FOOTER //
// ./src/enum.js